export const PERSIST_EXPANDED_ROUTES = 'PERSIST_EXPANDED_ROUTES';
export const PERSIST_SET_THEME_LIGHT = 'PERSIST_SET_THEME_LIGHT';
export const PERSIST_SET_EDIT_MODE = 'PERSIST_SET_EDIT_MODE';

// Default Views
export const PERSIST_PORTFOLIO_DEFAULT_VIEW = 'PERSIST_PORTFOLIO_DEFAULT_VIEW';
export const PERSIST_SETTINGS_DRAWERS_OPEN = 'PERSIST_SETTINGS_DRAWERS_OPEN';

export const PERSIST_ROLE_ACTIVE_NAME = 'PERSIST_ROLE_ACTIVE_NAME';
export const PERSIST_PAGE_ROLE_DEFAULT_VIEW = 'PERSIST_PAGE_ROLE_DEFAULT_VIEW';

// Gantt
export const PERSIST_GANTT_EXPANDED_TASKIDS = 'PERSIST_GANTT_EXPANDED_TASKIDS';
